import { PROJECT_TASK_TEMPLATE_TYPES } from 'lib'
import axiosInstance from './axiosInstance'

export const getProjectTemplateSectionTaskById = (taskId) => {
  return axiosInstance.get(`/project/template-section-tasks/${taskId}`)
}

export const getProjectTemplateSectionTasksBySectionId = (sectionId) => {
  return axiosInstance.get(`/project/template-section-tasks?sectionId=${sectionId}`)
}

export const getProjectTemplateSectionTasksByTemplateType = (type = PROJECT_TASK_TEMPLATE_TYPES.General) => {
  return axiosInstance.get(`/project/template-section-tasks/template-type?type=${type}`)
}

export const createProjectTemplateSectionTask = (data) => {
  return axiosInstance.post('/project/template-section-tasks', data)
}

export const updateProjectTemplateSectionTask = (taskId, data) => {
  return axiosInstance.put(`/project/template-section-tasks/${taskId}`, data)
}

export const deleteProjectTemplateSectionTask = (taskId) => {
  return axiosInstance.delete(`/project/template-section-tasks/${taskId}`)
}
